import { render, staticRenderFns } from "./RigidBodyViz.vue?vue&type=template&id=09edc42c&scoped=true"
import script from "./RigidBodyViz.vue?vue&type=script&lang=js"
export * from "./RigidBodyViz.vue?vue&type=script&lang=js"
import style0 from "./RigidBodyViz.vue?vue&type=style&index=0&id=09edc42c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09edc42c",
  null
  
)

export default component.exports